import React from 'react'

const AskYogiSvgIcon: React.FC = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.32813 0.419085C9.21205 0.164621 8.95759 0.00390625 8.6808 0.00390625C8.40402 0.00390625 8.14955 0.164621 8.03348 0.419085L5.67634 5.50837L0.587054 7.86105C0.332589 7.97712 0.171875 8.23159 0.171875 8.51284C0.171875 8.79409 0.332589 9.04409 0.587054 9.16016L5.6808 11.5128L8.02902 16.6021C8.14509 16.8566 8.39955 17.0173 8.67634 17.0173C8.95312 17.0173 9.20759 16.8566 9.32366 16.6021L11.6763 11.5084L16.7701 9.15569C17.0246 9.03962 17.1853 8.78516 17.1853 8.50837C17.1853 8.23159 17.0246 7.97712 16.7701 7.86105L11.6808 5.51283L9.32813 0.419085ZM17.3147 14.2896L14.7924 15.236C14.5915 15.3119 14.4576 15.5039 14.4576 15.7182C14.4576 15.9325 14.5915 16.1244 14.7924 16.2003L17.3147 17.1468L18.2612 19.6691C18.3371 19.87 18.529 20.0039 18.7433 20.0039C18.9576 20.0039 19.1496 19.87 19.2254 19.6691L20.1719 17.1468L22.6942 16.2003C22.8951 16.1244 23.029 15.9325 23.029 15.7182C23.029 15.5039 22.8951 15.3119 22.6942 15.236L20.1719 14.2896L19.2254 11.7673C19.1496 11.5664 18.9576 11.4325 18.7433 11.4325C18.529 11.4325 18.3371 11.5664 18.2612 11.7673L17.3147 14.2896Z"
      fill="currentColor"
    />
  </svg>
)

export default AskYogiSvgIcon
